<template>
    <div>
        <ob-spinner v-if="eadLoader" loading-text="Loading..."></ob-spinner>
        <div v-else>
             <div style="padding: 10px 0px 6px 14px;">
                    <h4 style="font-weight: 600;font-size: 15px;padding" v-if="docsList.length != 0" >Employment Authorization Document</h4>
            </div> 

            <div v-if="!eadLoader && docsList.length == 0" style="height: 400px;display:table;width:100%;">
                <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                    <h5 class="pfa-info_msg">
                        Once the employer uploads the EAD card, it will be reflected here.
                    </h5>
                </div>
            </div>
            
            <div class="ead-container pT0"  v-if="eadLoader != true && docsList.length > 0"> <!-- v-if="eadLoader != true && !emptySection" -->
                <div>
                    <!-- Document setions-->
                    <div v-if="docsList.length > 0">
                        <div class="row ead-content document-section" Style="border-top: 1px dashed #b5b5b5" v-for="(docObj, index) in docsList" :key="index">  
                            <div v-if="docObj.EADCard != null && docObj.EADCard.MetadataValues != null && docObj.EADCard.MetadataValues != ''">
                                <ob-ead-document :documentList="docObj.EADCard" :fileUploadUrl="fileUploadUrl" :redirectFrom="redirectfrom" :actionList="actionList" :entireData="eadData" :previousList="docObj.EADCard.IsExpired" :IsCAPGAP ="false" :FormI20Doc="formI20" @removeDoc="getEadDocs" @updateDoc="getEadDocs"> </ob-ead-document>
                            </div>
                            <div v-if="docObj.EADReceipt != null && docObj.EADReceipt.MetadataValues != null && docObj.EADReceipt.MetadataValues != ''">
                                <ob-ead-document  :documentList="docObj.EADReceipt" :fileUploadUrl="fileUploadUrl" :redirectFrom="redirectfrom" :actionList="actionList" :entireData="eadData" :previousList="docObj.EADReceipt.IsExpired" :IsCAPGAP ="false" :FormI20Doc="formI20" @removeDoc="getEadDocs" @updateDoc="getEadDocs"> </ob-ead-document>
                            </div>
                             <div v-if="docObj.EADFormI20 != null && docObj.EADFormI20.MetadataValues != null && docObj.EADFormI20.MetadataValues != ''">  
                            <!-- <ob-ead-document :documentObj="docObj.EADFormI20" :entireData="eadData" :previousList="false" :IsCAPGAP ="isCAPGAP" :redirectFrom="redirectfrom"> </ob-ead-document> -->
                            <ob-ead-document :documentList="docObj.EADFormI20" :fileUploadUrl="fileUploadUrl" :redirectFrom="redirectfrom" :actionList="actionList" :entireData="eadData" :previousList="docObj.EADFormI20.IsExpired" :IsCAPGAP="true" @removeDoc="getEadDocs" @updateDoc="getEadDocs"> </ob-ead-document>
                            </div>
                        </div>
                        <!-- <div v-if="isCAPGAP && formI20 && formI20.LinkedId == currentWorkAuthId">
                            <div class="row ead-content document-section">  
                                <ob-ead-document :documentList="formI20"  :entireData="eadData" :previousList="false" :IsCAPGAP ="isCAPGAP" :redirectFrom="redirectfrom"> </ob-ead-document>
                            </div>
                        </div> -->
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                docsList:[],
                currentWorkAuthId: '',
                eadData: {},

                eadLoader: false,
                dataEAD: {},
                dataEadCard: {},
                descCat: '',
                fileUploadUrl: '',
                actionList: [ { } ],
                extensible: '',
                expiredList: '',
                dataEadReceipt: '',
                showNoticeEad: '',
                emptySection: false,
                activeCardsList : [],
                activeCardIds:[],
                isAutoExtensionShow: false,
                redirectfrom:'Ead',
                isCAPGAP:false,
                formI20:{}
            }
        },
        methods:{
            getEadDocs() {
                this.eadLoader = true
               // if(loggedInUserObj.HireType == 'W2'){
                    ajax.get(`Employee/${loggedInUserObj.consultantId}/GetEADDocuments?orgId=${this.loggedInUserObj.orgId}&isESS=true`, {}, (res) => {
                        if (res.data.State == true) {
                            this.eadData = res.data.EADDocuments
                            this.docsList = this.eadData.EADDocList && this.eadData.EADDocList.length > 0 ? 
                                                this.eadData.EADDocList : []
                            this.metaData = this.eadData.MetaData
                            this.currentWorkAuthId = this.eadData.CurrentWorkAuthId
                            this.isCAPGAP = this.eadData.IsCAPGAP
                            this.formI20 = this.eadData.FormI20
                            // if(this.activeCardIds.length == 0 && this.expiredList.length == 0){
                            //     this.emptySection = true
                            // }else{
                            //     this.emptySection = false
                            // }
                            // var activeCards = this.activeCardsList && this.activeCardsList.length > 0 ? this.activeCardsList.filter(x => this.activeCardIds.includes(x.DocumentId)) : null
                            // if(activeCards && activeCards.length > 0 && (activeCards[0].DocumentType == 'EADCardInfo' || activeCards[0].DocumentType == 'EADCardReceiptNotice'))
                            //     this.isAutoExtensionShow = true
                            setTimeout(() => {
                                this.eadLoader = false
                            }, 2000)
                        }else{
                            this.eadLoader = false
                            this.ESSEnableDisable(res)
                            this.emptySection = true
                        }
                    })
               // }
            }
       },
       created(){
           this.getEadDocs()
       }, 
       watch:{
           emptySection(){
           }
       }
    }
</script>
<style lang="scss" scoped>
    @import "~styles/framework/vue-utils";
    .ead-container {
        padding:15px;
    }
    .ead-title {
       border-bottom:1px dashed #ccc;
       margin:10px 0;
       padding:10px 0;
       h3{
             font-weight:bold;
             color:#143361;
         }
    }
    // label for ead ext
    .auto-ext--ead {
        background: #4A90E2;
        padding: 4px 12px;
        border-radius: 15px;
        font-size: 11px;
        color: #fff;
        font-weight: 600;
    }
    .auto-not--ead {
        background: #A2A2A2;
        padding: 4px 12px;
        border-radius: 15px;
        font-size: 11px;
        color: #fff;
        font-weight: 600;

    }    
    .ead-content{
        margin:0px;
    }    
    /* document list */
    .document-section {
        // padding: 15px 0px;
        position:relative;
    }
    .document-list__body {
        padding-top: 5px !important;
    }
    .linkto-I9{
        text-decoration: underline;
        cursor:pointer;
    }
    .document-info {
        width: 15px;
        cursor: pointer;
        padding-left: 4px;
    }
    .displayTable{
        display:table;
    }    
    .pfa-body {
        padding: 15px;
        display: inline-block;
        .pfa-info_msg {
                color: $ob-brand-primary;
                font-size: 13px;
                line-height: 20px;
                margin: 0;
        }
    }    
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/EmpEAD.vue